// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";

import {Colors} from "../../../assets/Colors";
import {fetchGet, fetchPost, fetchPut} from "../../../fetchers";
import {useMutation} from "@tanstack/react-query";
import {DynamicTableSimple} from "../../../components/tablecard/DynamicTable";
import {Card} from "@material-tailwind/react";
import {isRequired, useForm} from "../../../components/isRequired";
import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import {HrdInputGenerator} from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import 'react-toastify/dist/ReactToastify.css';
import {BiArrowBack} from "react-icons/bi";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useUserBisnisUnit} from "../../../hooks/useUserBisnisUnit";

// User SO hanya boleh membuka dokumen unitnya sendiri — dokumen HO ditolak
// (halaman ini bisa dicapai lewat URL langsung, bukan cuma dari tabel report).
const SO_UNIT = "U0002";

// Helper attachment — sama seperti halaman approval (kas-bank/approval.js).
const extractFileName = (fileString) => {
    if (!fileString) return "";
    if (fileString.includes("-")) {
        const parts = fileString.split("-");
        return parts.slice(1).join("-");
    }
    return fileString;
};

const getFileIcon = (fileName) => {
    if (!fileName) return "📎";
    const ext = fileName.split(".").pop().toLowerCase();
    if (["pdf"].includes(ext)) return "📄";
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "🖼️";
    if (["doc", "docx"].includes(ext)) return "📝";
    return "📎";
};

const DetailKasBank = ({}) => {
    let initialState = {
        BisnisUnitID: "",
        Tanggal: new Date()
    };

    let initialStateModal = {
        SDTDate: new Date()
    };
    const validations = [(
        {UserPCName}) => isRequired(UserPCName) || {UserPCName: "Nama UserPC wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Status wajib diisi"},
        ({KelompokID}) => isRequired(KelompokID) || {KelompokID: "Kelompok wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Kelompok wajib diisi"},
        ({DetailAccountID}) => isRequired(DetailAccountID) || {DetailAccountID: "Detail Account wajib diisi"}, ({Status}) => isRequired(Status) || {Status: "Detail Account wajib diisi"},
    ];

    const {
        changed,
        values,
        isValid,
        touched,
        submitHandler,
        customHandler,
        changeHandler,
        errors,
        blastChange
    } = useForm(initialState, validations);


    const barang = useMutation(formData => fetchGet("Master/Barang/min"))
    const [buttonTouched, setButtonTouched] = useState(false);
    const [detail, setDetail] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [modalDetail, setModalDetail] = useState(initialStateModal);
    const [modalID, setModalID] = useState(0);
    const ModalOpener = (detail) => {
        setShowModal(true)
    }
    const param = useLocation();
    const params = useParams();

    // Bisnis Unit dokumen yang dibuka vs Bisnis Unit user login.
    const [rowBisnisUnit, setRowBisnisUnit] = useState("");
    const {bisnisUnitID: userBisnisUnit, resolved: buResolved} = useUserBisnisUnit();
    const isSO = userBisnisUnit === SO_UNIT;
    const isForeignUnit = rowBisnisUnit !== "" && rowBisnisUnit !== SO_UNIT;
    const accessDenied = isSO && isForeignUnit;
    // Sesi lama: BU user baru diketahui setelah fetch. Selama itu dokumen non-SO
    // ditahan dulu supaya isinya tak sempat terlihat user SO.
    const holdForeignUntilResolved = !buResolved && isForeignUnit;

    const mutation = useMutation(formData => fetchPost("Master/UserPC", formData))
    const mutationAdd = useMutation(formData => fetchPost("Accounting/CashJournal", formData))
    const mutationGet = useMutation(formData => fetchGet("Accounting/CashJournal/" + formData))
    const mutationUpdate = useMutation(formData => fetchPut("Accounting/CashJournal/approval", formData))
    const mutationApproval = useMutation(formData => fetchPost("Accounting/CashJournal/kirim", formData))
    const detailAccount = useMutation(formData => fetchGet("GetMinMasterDetailAccountV2"))

    const ModalEdit = (detail, id) => {
        setModalID(id)
        setModalDetail(detail)
        setShowModal(true)
        setShowModalEdit(true)
    }

    const ModalDelete = (id) => {
        let newDetail = [...detail]
        newDetail.splice(id, 1);
        let totals = 0
        newDetail.map(({Nominal}, id) => {
            totals += parseFloat(Nominal)
        })
        customHandler(totals, "Nominal")
        setDetail(newDetail)
    }

    const navigate = useNavigate();

    useEffect(() => {
        detailAccount.mutate()

        barang.mutate()
        if (params.transid) {
            mutationGet.mutate(params.transid.toString().replaceAll("-", "/"))
        }

    }, []);

    useEffect(() => {
        if (mutationUpdate.isSuccess) {
            navigate(getBackNavigationPath());
        }
    }, [mutationUpdate.status]);


    useEffect(() => {
        if (mutationAdd.isSuccess) {
            navigate(getBackNavigationPath());
        }
    }, [mutationAdd.status]);

    useEffect(() => {
        if (mutationApproval.isSuccess) {
            navigate(getBackNavigationPath());
        }
    }, [mutationApproval.status]);
    useEffect(() => {
        if (mutationGet.data) {
            const row = mutationGet.data.data?.[0]
            if (!row) return
            setRowBisnisUnit(row.BisnisUnitID ?? "")
            setDetail(row.Data ?? [])
            blastChange(row)
        }
    }, [mutationGet.status]);

    const getBackNavigationPath = () => {
        const bisnisUnitID = values.BisnisUnitID;
        const jenisTransaksi = values.JenisTransaksi;
        if (jenisTransaksi === "Penerimaan") return "/finance/report/penerimaan-dana";
        if (bisnisUnitID === "U0001") return "/finance/report/Petty-Cash-HO";
        if (bisnisUnitID === "U0002") return "/finance/report/pembayaran-non-po";
        return "/approval-list";
    };

    // Fungsi untuk menampilkan label berdasarkan BisnisUnitID
    const getBackButtonLabel = () => {
        const jenisTransaksi = values.JenisTransaksi;
        const bisnisUnitID = values.BisnisUnitID;

        if (jenisTransaksi === "Penerimaan") return "Kembali ke Penerimaan Dana";
        if (bisnisUnitID === "U0001") return "Kembali ke Monitoring HO";
        if (bisnisUnitID === "U0002") return "Kembali ke Monitoring SO";
        return "Kembali";
    };

    // Fungsi untuk menampilkan badge berdasarkan BisnisUnitID
    const getBisnisUnitBadge = () => {
        const bisnisUnitID = values.BisnisUnitID;
        
        if (bisnisUnitID === "U0001") {
            return (
                <span className="px-2 py-1 bg-green-100 text-green-800 text-xs font-medium rounded-full ml-2">
                    HO
                </span>
            );
        } else if (bisnisUnitID === "U0002") {
            return (
                <span className="px-2 py-1 bg-orange-100 text-orange-800 text-xs font-medium rounded-full ml-2">
                    SO
                </span>
            );
        }
        return null;
    };

    const header = [
        {name: "Account", key: "Account", modifiers: "Account"},
        {name: "Account Name", key: "Account", modifiers: "AccountName"},
        {name: "Keterangan", key: "Keterangan", modifiers: "Keterangan"},
        {name: "Nominal", key: "Nominal", modifiers: "Numbers"},
    ]

    // Buka file attachment — identik dgn halaman approval.
    const getDataFromURL = (url) => {
        if (!url || url.trim() === "") {
            alert("Tidak ada file attachment");
            return;
        }

        const encodedUrl = encodeURIComponent(url);
        const fileUrl = process.env.REACT_APP_API_UPLOAD_URL
            ? `${process.env.REACT_APP_API_UPLOAD_URL}file/${encodedUrl}`
            : `http://192.168.212.24:5000/v1/files/${encodedUrl}`;

        fetch(fileUrl, {method: "GET", headers: {Accept: "application/octet-stream"}})
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.blob();
            })
            .then((blob) => {
                const fileBlobUrl = window.URL.createObjectURL(blob);
                if (blob.type.includes("pdf") || blob.type.includes("image")) {
                    window.open(fileBlobUrl, "_blank");
                } else {
                    const link = document.createElement("a");
                    link.href = fileBlobUrl;

                    let downloadName = url;
                    if (url.includes("-") && url.split("-")[0].length === 36) {
                        const uuidParts = url.split("-");
                        downloadName = uuidParts.slice(1).join("-").replace(/_/g, " ");
                    }

                    link.download = downloadName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setTimeout(() => URL.revokeObjectURL(fileBlobUrl), 100);
                }
            })
            .catch((err) => {
                console.error("Error loading file:", err);
                alert("Gagal membuka file. File mungkin belum diupload ke server.");
            });
    };

    // Susunan jurnal — aturan PERSIS sama dgn preview di halaman approval dan dgn
    // ApproveCashJournal di backend: baris kas/bank memakai DetailCashJournal, baris
    // lawan dari CashJournalList. Pengeluaran/Downpayment PO -> kas/bank di KREDIT,
    // lawan di DEBET; selain itu sebaliknya.
    //
    // Tabel "Detail Account" di bawah hanya memuat sisi lawan, sehingga jurnal terlihat
    // sepihak — bagian ini melengkapinya dgn baris kas/bank + posisi Debet/Kredit.
    const namaAkun = (coa) => {
        const list = (detailAccount.data && detailAccount.data.data) || [];
        const found = list.find(({value}) => value === coa);
        return found ? found.label : "";
    };
    const isPengeluaran =
        values.JenisTransaksi === "Pengeluaran" ||
        values.JenisTransaksi === "Downpayment PO";
    // Halaman ini melayani DUA arah uang: 2.841 dokumen pengeluaran dan 318
    // penerimaan. Label yang berbunyi "Dibayar kepada" pada dokumen penerimaan
    // membaca terbalik dari kenyataannya, jadi ketiga judul di bawah mengikuti
    // arah dokumennya — bukan diganti serentak.
    const isPenerimaan = values.JenisTransaksi === "Penerimaan";
    const nominalHeader = parseFloat(values.Nominal || 0) || 0;
    const jurnalRows = [];
    if (values.DetailCashJournal) {
        jurnalRows.push({
            coa: values.DetailCashJournal,
            nama: namaAkun(values.DetailCashJournal),
            debet: isPengeluaran ? 0 : nominalHeader,
            kredit: isPengeluaran ? nominalHeader : 0,
        });
    }
    (detail || []).forEach((d) => {
        const n = parseFloat(d.Nominal || 0) || 0;
        jurnalRows.push({
            coa: d.Account,
            nama: namaAkun(d.Account),
            debet: isPengeluaran ? n : 0,
            kredit: isPengeluaran ? 0 : n,
        });
    });
    const totDebet = jurnalRows.reduce((a, r) => a + r.debet, 0);
    const totKredit = jurnalRows.reduce((a, r) => a + r.kredit, 0);
    const selisih = totDebet - totKredit;
    const rp = (v) =>
        (parseFloat(v || 0) || 0).toLocaleString("in-ID", {maximumFractionDigits: 0});

    // Status "1" = sudah di-approve, jurnal benar-benar sudah diposting ke Accounting.
    // Selain itu dokumen belum diposting, jadi tabel di bawah masih berupa rencana.
    const sudahDiposting = String(values.Status) === "1";

    const modalHandler = (value, names) => {
        const newValues = {...modalDetail, [names]: value};
        setModalDetail(newValues);
    };

    const modalHandlerText = (event) => {
        const newValues = {...modalDetail, [event.target.name]: event.target.value};
        setModalDetail(newValues);
    };

    const inputBuilder = [
        {
            type: "DetailAccount",
            name: "Account",
            title: "Account",
            handler: modalHandler,
            size: "full",
            required: false,
            disabled: true,
            edit: false
        },
        {
            type: "text",
            name: "Keterangan",
            title: "Keterangan",
            handler: modalHandlerText,
            size: "full",
            required: false,
            disabled: true,
            edit: false
        },
        {
            type: "numberFormatSatu",
            name: "Nominal",
            title: "Nominal",
            handler: modalHandlerText,
            size: "full",
            required: false,
            disabled: true,
            edit: false
        },
    ]


    const Kirim = (id) => {
        let newValues = {...values};
        try {
            newValues["Tanggal"] = newValues["Tanggal"].toISOString()
            newValues["Nominal"] = newValues["Nominal"].toString()
        } catch (err) {
        }

        newValues["Data"] = detail
        newValues["Status"] = id

        mutationUpdate.mutate(newValues)
    }


    // Dokumen milik unit lain: user SO ditolak, dan selama BU user belum diketahui
    // isinya ditahan dulu (bukan ditolak — user HO tetap boleh membukanya).
    if (accessDenied || holdForeignUntilResolved) {
        return (<div className="md:ml-64">
            <div
                style={{background: Colors.primary}}
                className="pt-14 pb-16 px-3 md:px-8 h-auto"
            >
                <div className="container mx-auto max-w-full"/>
            </div>
            <div className="px-3 md:px-8 h-auto -mt-32">
                <div className="container mx-auto max-w-full">
                    <div className="grid grid-cols-1 px-4">
                        <Card>
                            <div className="flex flex-col items-center justify-center p-10 text-center">
                                {accessDenied ? (<>
                                    <h2 className="text-xl font-bold text-gray-800">
                                        Akses Ditolak
                                    </h2>
                                    <p className="mt-2 max-w-md text-sm text-gray-600">
                                        Dokumen {params.transid || "ini"} milik Bisnis Unit
                                        lain. Akun Anda hanya dapat membuka dokumen SO.
                                    </p>
                                    <button
                                        onClick={() => navigate("/finance/report/pembayaran-non-po")}
                                        className="mt-6 flex flex-row items-center justify-center bg-white hover:bg-blue-50 hover:text-blue-700 text-gray-800 font-medium py-2.5 px-4 border border-gray-300 rounded-lg shadow-sm transition-colors duration-200"
                                    >
                                        <BiArrowBack className="text-lg mr-2"/>
                                        Kembali ke Monitoring
                                    </button>
                                </>) : (
                                    <p className="text-sm text-gray-500">
                                        Memeriksa hak akses…
                                    </p>
                                )}
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </div>);
    }

    return (<div className="md:ml-64">
        <div
            style={{background: Colors.primary}}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="container mx-auto max-w-full">
                <div className="grid grid-cols-1 px-4">
                    <Card>
                        <div className="flex flex-col mt-5 p-6">
                            {/* Header dengan tombol kembali */}
                            <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
                                <div className="mb-4 md:mb-0">
                                    <h2 className="text-xl font-bold text-gray-800">
                                        Detail Kas Bank
                                        {getBisnisUnitBadge()}
                                    </h2>
                                    <p className="text-gray-600 text-sm mt-1">
                                        ID Transaksi: {params.transid || "-"}
                                    </p>
                                </div>
                                
                                <button
                                    onClick={() => navigate(getBackNavigationPath())}
                                    className="flex flex-row items-center justify-center bg-white hover:bg-blue-50 hover:text-blue-700 text-gray-800 font-medium py-2.5 px-4 border border-gray-300 rounded-lg shadow-sm transition-colors duration-200"
                                >
                                    <BiArrowBack className="text-lg mr-2" />
                                    {getBackButtonLabel()}
                                </button>
                            </div>

                            {/* Informasi Bisnis Unit */}
                            {values.BisnisUnitID && (
                                <div className="mb-6 p-3 bg-blue-50 rounded-lg border border-blue-100">
                                    <div className="flex items-center text-sm text-blue-700">
                                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                                        <span className="font-medium">
                                            Bisnis Unit: {values.BisnisUnitID} 
                                            {values.BisnisUnitID === "U0001" ? " (Head Office)" : 
                                             values.BisnisUnitID === "U0002" ? " (Site Office)" : ""}
                                        </span>
                                    </div>
                                </div>
                            )}

                            {/* Form Detail */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
                                <div>
                                    <HrdInputGenerator 
                                        type={"BisnisUnit"} 
                                        value={values} 
                                        name={"BisnisUnitID"}
                                        title={"Bisnis Unit"}
                                        onChange={customHandler} 
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator 
                                        type={"JenisTransaksiKasBank"} 
                                        value={values} 
                                        name={"JenisTransaksi"}
                                        title={"Jenis Transaksi"}
                                        onChange={customHandler} 
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator 
                                        type={"text"} 
                                        value={values} 
                                        name={"DariKepada"}
                                        title={isPenerimaan ? "Terima Dari" : "Dibayar kepada"}
                                        onChange={changeHandler} 
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator 
                                        type={"JenisPenerimaan"} 
                                        value={values} 
                                        name={"JenisCashJournal"}
                                        title={isPenerimaan ? "Jenis Penerimaan" : "Jenis Pembayaran"}
                                        onChange={customHandler} 
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator 
                                        type={"DetailPembayaran"} 
                                        value={values} 
                                        name={"DetailCashJournal"}
                                        title={isPenerimaan ? "Detail Penerimaan" : "Detail Pembayaran"}
                                        onChange={customHandler} 
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator 
                                        type={"dateOnly"} 
                                        value={values} 
                                        name={"Tanggal"}
                                        title={"Tanggal"}
                                        onChange={customHandler}
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div className="md:col-span-2">
                                    <HrdInputGenerator 
                                        type={"text"} 
                                        value={values} 
                                        name={"Keterangan"}
                                        title={"Keterangan"}
                                        onChange={changeHandler} 
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true} 
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator
                                        type={"numberFormatSatu"}
                                        value={values}
                                        name={"Nominal"}
                                        title={"Nominal"}
                                        onChange={changeHandler}
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={true}
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                                <div>
                                    <HrdInputGenerator
                                        type={"text"}
                                        value={values}
                                        name={"NoCek"}
                                        title={"No Cek atau bilyet giro"}
                                        onChange={changeHandler}
                                        touched={touched}
                                        buttonTouched={buttonTouched}
                                        size={"full"}
                                        required={false}
                                        errors={errors}
                                        disabled={true}
                                    />
                                </div>
                            </div>

                            {/* ATTACHMENT (VIEW ONLY) — sama seperti halaman approval */}
                            {values.File && values.File.trim() !== "" && (
                                <div className="mb-6">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                                        Attachment
                                        <span className="text-blue-600 text-xs ml-2">
                                            ✓ File tersedia
                                        </span>
                                    </label>

                                    <button
                                        type="button"
                                        onClick={() => getDataFromURL(values.File)}
                                        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 border border-blue-600 rounded shadow-sm"
                                    >
                                        Lihat File
                                    </button>

                                    <div className="mt-2 p-2 bg-gray-50 rounded border">
                                        <div className="flex items-center">
                                            <span className="text-lg mr-2">
                                                {getFileIcon(extractFileName(values.File))}
                                            </span>
                                            <span className="text-sm text-gray-700 truncate">
                                                {extractFileName(values.File)}
                                            </span>
                                        </div>
                                        {values.File.includes("-") && (
                                            <p className="text-xs text-gray-500 mt-1">
                                                UUID: {values.File.split("-")[0]}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            )}

                            <hr className="my-6"/>
                            
                            {/* Table Detail Account */}
                            <div className="mb-6">
                                <h3 className="text-lg font-medium text-gray-700 mb-4">
                                    Detail Account
                                </h3>
                                <DynamicTableSimple 
                                    data={detail}
                                    header={header}
                                    Master={false}
                                    OnClick={ModalOpener}
                                    name={"Purchase Requisition"}
                                    barang={barang.data}
                                    edit={ModalEdit}
                                    delete={ModalDelete}
                                    account={detailAccount.data}
                                />
                            </div>

                            {/* JURNAL LENGKAP — Detail Account di atas hanya sisi lawan;
                                di sini baris kas/bank ikut ditampilkan beserta posisi
                                Debet/Kredit, sama seperti preview di halaman approval. */}
                            <div className="mb-6">
                                <h3 className="text-lg font-medium text-gray-700 mb-1">
                                    {sudahDiposting
                                        ? "Jurnal (sudah diposting)"
                                        : "Jurnal (belum diposting — terbentuk saat di-approve)"}
                                </h3>
                                <p className="text-xs text-gray-500 mb-4">
                                    Termasuk baris kas/bank yang tidak tampil pada tabel Detail Account.
                                </p>
                                <div className="overflow-x-auto">
                                    <table className="min-w-full text-sm border border-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-700 border-b">No Akun</th>
                                                <th className="py-2 px-3 text-left font-semibold text-gray-700 border-b">Nama Akun</th>
                                                <th className="py-2 px-3 text-right font-semibold text-gray-700 border-b">Debet</th>
                                                <th className="py-2 px-3 text-right font-semibold text-gray-700 border-b">Kredit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {jurnalRows.map((r, i) => (
                                                <tr key={i} className="border-b last:border-b-0">
                                                    <td className="py-2 px-3 text-gray-800">{r.coa}</td>
                                                    <td className="py-2 px-3 text-gray-800">{r.nama}</td>
                                                    <td className="py-2 px-3 text-right text-gray-800">{r.debet ? rp(r.debet) : "-"}</td>
                                                    <td className="py-2 px-3 text-right text-gray-800">{r.kredit ? rp(r.kredit) : "-"}</td>
                                                </tr>
                                            ))}
                                            <tr className="font-bold bg-gray-50">
                                                <td className="py-2 px-3" colSpan={2}>TOTAL</td>
                                                <td className="py-2 px-3 text-right">{rp(totDebet)}</td>
                                                <td className="py-2 px-3 text-right">{rp(totKredit)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                {selisih !== 0 && (
                                    <div className="mt-2 text-sm font-semibold text-red-600">
                                        ⚠ Jurnal tidak seimbang — selisih {rp(Math.abs(selisih))}.
                                    </div>
                                )}
                            </div>
                        </div>
                    </Card>
                    <Modal
                        size="lg"
                        active={showModal}
                        toggler={() => {
                            setShowModal(false);
                        }}
                    >
                        <ModalHeader
                            className="mt-20"
                            toggler={() => {
                                setShowModal(false);
                                setShowModalEdit(false);
                            }}
                        >

                            {showModalEdit ? "Edit Data" : "Tambah Data"}
                        </ModalHeader>
                        <ModalBody>
                            <form className="w-full " onSubmit={submitHandler}>
                                {inputBuilder.map(({
                                                       type,
                                                       name,
                                                       title,
                                                       handler,
                                                       modifiers,
                                                       size,
                                                       required,
                                                       disabled,
                                                       edit,
                                                   }, id) => {
                                    if (!edit || showModalEdit) {
                                        return (
                                            <HrdInputGenerator type={type} value={modalDetail} name={name} title={title}
                                                               onChange={handler} touched={touched}
                                                               buttonTouched={buttonTouched}
                                                               modifiers={modifiers} size={size}
                                                               required={required} errors={errors}
                                                               disabled={disabled}
                                            />
                                        )
                                    }
                                })}
                            </form>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                color="red"
                                buttonType="link"
                                onClick={() => {
                                    setShowModal(false);
                                    setShowModalEdit(false);
                                }}
                                ripple="dark"
                            >
                                Cancel
                            </Button>

                            <Button
                                color={(isValid || (!isValid)) ? "green" : "blueGray"}
                                disabled={mutation.isLoading}
                                onClick={() => {
                                    if (!isValid && changed) {
                                        setButtonTouched(true);
                                    }
                                    let tempIsValid = isValid;
                                    if (!isValid) {
                                    }
                                    if (showModalEdit) {
                                        let newValues = [...detail];
                                        newValues[modalID] = modalDetail
                                        let totals = 0
                                        newValues.map(({Nominal}, id) => {
                                            totals += parseFloat(Nominal)
                                        })
                                        customHandler(totals, "Nominal")
                                        setDetail(newValues);
                                        setModalDetail(initialStateModal)
                                        setShowModal(false)
                                        setShowModalEdit(false)
                                    } else {
                                        const newValues = [...detail, modalDetail];
                                        let totals = 0
                                        newValues.map(({Nominal}, id) => {
                                            totals += parseFloat(Nominal)
                                        })
                                        customHandler(totals, "Nominal")

                                        setDetail(newValues);
                                        setModalDetail(initialStateModal)
                                        setShowModal(false)
                                    }
                                }}
                                ripple={isValid ? "light" : ""}
                            >
                                {showModalEdit ? "Ubah" : "Tambah"}
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
        </div>
    </div>);
};

export default DetailKasBank;